import React from 'react';
import { Button } from 'reactstrap';

export const ButtonLoginInNewQueue = ({
  disabled = false,
  action = () => {}
}) => {
  return (
    <div className="text-center  py-3">
      <Button
        color="link"
        onClick={() => {
          if (!disabled) action();
          return;
        }}
        disabled={disabled}
        style={{
          cursor: disabled ? 'not-allowed' : 'pointer'
        }}
      >
        Logar em Novas Filas
      </Button>
    </div>
  );
};
